export const NFT_CONTRACT_ADDRESS =
  "0x0Ba3AaBEC88b51F139A61af29B07fd53bCcB278a";

export const TOTAL_MINT = 5555;

export const RATE = 0.0005;
